import type React from 'react';
import leftArrow from './slide-arrow-left.png';
import rightArrow from './slide-arrow-right.png';
import styles from './styles.module.less'; // 使用LESS模块导入

export interface SlideArrowButtonProps {
  /**
   * 按钮方向，left为左箭头，right为右箭头
   */
  direction: 'left' | 'right';
  /**
   * 点击事件回调
   */
  onClick?: () => void;
  /**
   * 是否禁用
   */
  disabled?: boolean;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 自定义样式
   */
  style?: React.CSSProperties;
  /**
   * 按钮大小
   */
  size?: 'small' | 'medium' | 'large';
}

/**
 * 轮播图左右箭头按钮组件
 */
export const SlideArrowButton: React.FC<SlideArrowButtonProps> = ({
  direction,
  onClick,
  disabled = false,
  className = '',
  style = {},
  size = 'medium',
}) => {
  // 根据方向、大小和类型生成类名
  const buttonClassName = [
    styles['slide-arrow-button'],
    styles[`slide-arrow-button--${size}`],
    disabled ? styles['slide-arrow-button--disabled'] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // 根据方向获取对应的箭头图片
  const getArrowImage = () => {
    return direction === 'left' ? leftArrow : rightArrow;
  };

  return (
    <button
      className={buttonClassName}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={style}
      aria-label={`${direction} arrow`}
      type="button"
    >
      <img
        src={getArrowImage()}
        alt={direction === 'left' ? 'arrow-left' : 'arrow-right'}
        className={styles['slide-arrow-button__icon']}
      />
    </button>
  );
};

export default SlideArrowButton;
